import { Menu, X } from "lucide-react"

export const MobileMenu = ({ isOpen, onClick }) => {
    return (
        <button className="md:hidden" onClick={onClick}>
            {isOpen ? (
                <X className="w-6 h-6" />
            ) : (
                <Menu className="w-6 h-6" />
            )}
        </button>
    )
}